/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {LegalEntitySubsidiaryDTO} from './LegalEntitySubsidiaryDTO';

/**
 * The LegalEntityParentCompanyDTO model module.
 * @module model/LegalEntityParentCompanyDTO
 * @version v0
 */
export class LegalEntityParentCompanyDTO {
  /**
   * Constructs a new <code>LegalEntityParentCompanyDTO</code>.
   * @alias module:model/LegalEntityParentCompanyDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>LegalEntityParentCompanyDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LegalEntityParentCompanyDTO} obj Optional instance to populate.
   * @return {module:model/LegalEntityParentCompanyDTO} The populated <code>LegalEntityParentCompanyDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new LegalEntityParentCompanyDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('legalEntitySubsidiaries'))
        obj.legalEntitySubsidiaries = ApiClient.convertToType(data['legalEntitySubsidiaries'], [LegalEntitySubsidiaryDTO]);
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
      if (data.hasOwnProperty('authorityCode'))
        obj.authorityCode = ApiClient.convertToType(data['authorityCode'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
LegalEntityParentCompanyDTO.prototype.id = undefined;

/**
 * @member {Array.<module:model/LegalEntitySubsidiaryDTO>} legalEntitySubsidiaries
 */
LegalEntityParentCompanyDTO.prototype.legalEntitySubsidiaries = undefined;

/**
 * @member {String} name
 */
LegalEntityParentCompanyDTO.prototype.name = undefined;

/**
 * @member {Boolean} active
 */
LegalEntityParentCompanyDTO.prototype.active = undefined;

/**
 * @member {String} authorityCode
 */
LegalEntityParentCompanyDTO.prototype.authorityCode = undefined;

